export * from "./MiddlewareStack";
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsY0FBYyxtQkFBbUIsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCAqIGZyb20gXCIuL01pZGRsZXdhcmVTdGFja1wiO1xuIl19


//////////////////
// WEBPACK FOOTER
// ./~/@aws-sdk/middleware-stack/dist/es/index.js
// module id = 862
// module chunks = 0